import { Button } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

export default function SenderSettingsHeader() {
    return (
        <div className="marketing-settings__header">
            <Button onClick={() => {}}>{getLiteral('create_new_sender')}</Button>
        </div>
    );
}
